import { isEmpty, pathOr } from 'ramda';
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Theme } from '@mui/material/styles/createTheme';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { renderTimeZonesList } from 'src/utilities/timezones/utilities';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        item: {},
        label: {
            color: theme.palette.basic.grey,
            fontSize: '12px',
            fontWeight: 400,
        },
        container: {
            alignItems: 'center',
        },
        value: {
            flexGrow: 1,
            fontSize: '14px',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
        },
        valueContainer: {
            flexBasis: 'auto',
            maxWidth: '100%'
        },
        inputBox: {
            marginTop: 6,
            marginBottom: 8,
            borderColor: pathOr('', ['palette', 'gray', 'darkGray'], theme),
            '& MuiSelect-icon': {
                color: `${pathOr('', ['palette', 'gray', 'softGray'], theme)} !important`,
            },
            '& fieldset': {
                borderColor: `${pathOr('', ['palette', 'gray', 'lightGray'], theme)} !important`,
            }
        }
    })
);

interface Props {
    value: any;
    isEdit: boolean;
    name: string;
    onHandleDropdownChange: any;
}

const TimeZones: React.FC<Props> = (props: Props) => {
    const {
        onHandleDropdownChange,
        value,
        isEdit,
        name
    } = props;
    const classes = useStyles();

    const createFilter = createFilterOptions();

    const timezoneList = renderTimeZonesList();

    return (
        <Box className={classes.item}>
            <Box className={classes.container}>
                {isEdit ? <Autocomplete
                    disabled={isEmpty(timezoneList)}
                    value={value}
                    onChange={(event: any, value: any) => onHandleDropdownChange(pathOr('', ['label'], value), name)}
                    defaultValue={value}
                    options={timezoneList}
                    size="small"
                    className={classes.inputBox}
                    filterOptions={(options, params) => {
                        const filtered = createFilter(options, params);
                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option: any) => inputValue === option.value);
                        if (inputValue !== '' && !isExisting) {
                            filtered.push({
                                value: inputValue,
                                label: inputValue,
                            });
                        }
                        return filtered;
                    }}
                    renderInput={(params: any) => <TextField size="small" {...params} />}
                />
                    :
                    <>
                        <Grid container w-100>
                            <Grid item xs={9} className={classes.valueContainer} display="flex" alignItems="center">
                                <Typography className={classes.value}>{value}</Typography>
                            </Grid>
                        </Grid>
                    </>
                }
            </Box>
        </Box>
    );
};

export default TimeZones;